/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const FlashIcon = /*#__PURE__*/ createSvgIcon(
  'FlashIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.59.146L11.487 7.86h5.02l-9.1 11.984 1.105-7.624H3.498L12.59.146zM5.503 11.22h4.165l-.716 4.936 5.54-7.296h-4.159l.717-5.006-5.548 7.366z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default FlashIcon;
